import LoginIcon from '@mui/icons-material/Login';

export const sliderMenuList = [
  { id: 1, name: "Inspector Login", link: "/inspection-login", icon: <LoginIcon/>, onClick: false },
  // { id: 2, name: "Home", link: "/", icon: "", onClick: false },
  // { id: 4, name: "Logout", link: "", icon: "", onClick: true },
];
